export default "__VITE_ASSET__fe0ffc5a__"